import UsersPage from './Users';

export default UsersPage;
